import { NgxLoggerLevel } from 'ngx-logger';


const companyConfig: any = {
  logo: './assets/alleanza-logo.png',
  logoBg: 'bg231f20',
  name: 'DIAS Alleanza',
  role: '*',
};

const grantedMailAddresses: string[] = [];

export const globalEnvironment = {
  name: 'DIAS Alleanza',
  production: false,
  company: companyConfig,
  routes: [],
  auth: {
    refreshing_time: 5000,
    token_lifespan: 60,
    bearerExcludedUrls: ['//wms.tidetech.org', '//wmts.tidetech.org'],
    grantedMailAddresses,
  },
  api: {
    seismicEvents: 'seismic/events',
    geojson: 'seismic/geojson',
  },
  logger: {
    serverLoggingUrl: 'http://localhost:3000/logs',
    level: NgxLoggerLevel.DEBUG,
    serverLogLevel: NgxLoggerLevel.ERROR,
  },
  render_delay: 400,
  refreshing_time: '10s',
  warn_timeout: 5000,
  error_timeout: 10000,
  snackbar_duration: 2000,
  snackbar_error_duration: 10000,
  date_format: 'MM-dd-yyyy HH:mm',
  first_available_date: '2021-01-01',
  supportUrl: 'https://support.cube.rina.org',
  google: {
    analytics: {
      active: true,
      uaId: 'UA-128968550-2',
      logging: {
        debug: false,
        exceptions: true,
        verbose: false,
      },
    },
  },
};
